import { createFileRoute } from '@tanstack/react-router';
import { OrgFunctionDetailPage } from '@/pages/organization/org-functions/OrgFunctionDetailPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';

export const Route = createFileRoute('/$slug/organization/teams/$orgFunctionId')({
  loader: createEntityBreadcrumbLoader('team', 'orgFunctionId'),
  component: RouteComponent
});

function RouteComponent() {
  const { orgFunctionId } = Route.useParams();
  return <OrgFunctionDetailPage orgFunctionId={orgFunctionId} kind="team" />;
}
